import React from 'react';
import _ from 'lodash';
import { object, func } from 'prop-types';
import I18n from '@fiverr-private/fiverr_context/src/I18n';
import Reviews from '@fiverr-private/reviews/src/reviews';
import SafePureComponent from '../shared/SafePureComponent';
import { BQ_CLICKED_REVIEWS_SNIPPET_MORE} from '../../utils/bigQueryEvents';
import { validateReviews } from '../../utils/mainComponentsValidator';
import { PAGE_NAME } from '../../utils/events';
import { REVIEWS } from '../../utils/pageSections';
import TextButton from './TextButton';

import './style.scss';

export const REVIEWS_SNIPPET_MIN_VALUE = 4.1;
export const REVIEWS_SNIPPET_MIN_AMOUNT = 3;

const shouldDisplayReviewsSnippet = ({reviewsSnippet}) => (
    reviewsSnippet.length >= REVIEWS_SNIPPET_MIN_AMOUNT
);

const getReviewsSnippet = (reviews) => (
    reviews.reviews.filter(({value, score}) => value >= REVIEWS_SNIPPET_MIN_VALUE && score)
);

const ReviewsSnippet = (
    {
        reviews = {},
        scrollToSection = _.noop
    }, { biEvents, requestContext }) => {

    if (!validateReviews({reviews, error: false})) {
        return null;
    }

    const {
        page_ctx_id: pageCtxId
    } = requestContext;

    const enrichData = {
        pageCtxId,
        pageName: PAGE_NAME
    };

    const reviewsSnippet = getReviewsSnippet(reviews);

    if (!shouldDisplayReviewsSnippet({reviewsSnippet})) {
        return null;
    }

    const viewMoreClick = () => {
        biEvents.sendBigQueryEvent({eventName: BQ_CLICKED_REVIEWS_SNIPPET_MORE});
        scrollToSection({ sectionKey: REVIEWS });
    };

    return (
        <div className="gig-reviews-snippet">
            <header>
                <h2 className="section-title"><I18n k={'gig_page_perseus.reviews_snippet.title'}/></h2>
                <TextButton text={'gig_page_perseus.reviews_snippet.view_all'}
                    onClick={viewMoreClick}/>
            </header>
            <Reviews initialState={({...reviews, reviews: reviewsSnippet, ...enrichData})} asCarousel/>
        </div>
    );

};

ReviewsSnippet.propTypes = {
    reviews: object,
    scrollToSection: func
};

ReviewsSnippet.contextTypes = {
    requestContext: object,
    biEvents: object
};

export { ReviewsSnippet };
export default SafePureComponent(ReviewsSnippet);
